import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/videos/about-hero.mp4")